<script lang="ts" setup>
import PublicHeader from '@/components/public-page/PublicHeader.vue'
import PublicFooter from '@/components/public-page/PublicFooter.vue'
</script>

<template>
  <div class="not-found-page">
    <PublicHeader />
    <div class="wrapper">
      <img src="@/assets/images/404.svg" alt="404" />
      <h1>{{ $t('NotFoundPage.title') }}</h1>
      <p>{{ $t('NotFoundPage.description') }}</p>
      <GsButton href="https://www.getgreenspark.com/" type="success">
        {{ $t('NotFoundPage.button') }}
      </GsButton>
    </div>
    <PublicFooter />
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-items: center;
  flex-direction: column;
  max-width: 935px;
  margin: 0 auto;
  text-align: center;
  padding: 120px 12px 60px;
  gap: 20px;

  @include media('md-and-up') {
    gap: 40px;
    padding: 135px 0 80px;
  }

  img {
    max-width: 100%;
  }

  h1 {
    font-size: 24px;
    font-weight: 700;

    @include media('md-and-up') {
      font-size: 40px;
    }
  }

  p {
    font-size: 16px;

    @include media('md-and-up') {
      font-size: 32px;
    }
  }
}
</style>
